export default __webpack_public_path__ + "static/media/Gymnastics Hall, Ambala1.7263539a.jpg";